<template>
    <div id="notifications-template">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                { text: 'Kode Voucher', to: { path: '/kode-voucher' } },
                { text: 'Detail Kode Voucher' },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <div>
            <v-row>
                <v-col cols="6" md="6">
                    <h3 class="header-text font-weight-bold">
                        Detail Kode Voucher
                    </h3>
                </v-col>

                <v-col cols="6" md="6" class="pr-2 pt-4 text-right">
                    <v-btn
                        color="blew"
                        depressed
                        dark
                        @click="updateVoucherCode()"
                    >
                        <v-icon class="mr-2" style="font-size: 18px"
                            >mdi-pencil</v-icon
                        >
                        Edit
                    </v-btn>
                </v-col>
            </v-row>
        </div>

        <div>
            <v-card flat>
                <v-card-text class="px-8">
                    <v-row class="mt-2 mb-4">
                        <v-col cols="6" class="pt-3">
                            <v-row class="mb-4">
                                <v-col cols="4" class="font-weight-500">
                                    Nama Voucher
                                </v-col>
                                <v-col cols="8">
                                    <span
                                        class="darkgrey--text font-weight-bold"
                                    >
                                        Diskon Gedee Biar MAKIN AMBISS

                                        <v-btn
                                            class="green--text ml-3"
                                            color="#e2f5ea"
                                            depressed
                                            rounded
                                        >
                                            Aktif
                                        </v-btn>
                                    </span>
                                </v-col>
                            </v-row>

                            <v-row class="mb-4">
                                <v-col cols="4" class="font-weight-500">
                                    Periode Voucher
                                </v-col>
                                <v-col cols="8">
                                    <span
                                        class="darkgrey--text font-weight-bold"
                                    >
                                        2024-01-17 s/d 2024-02-30
                                    </span>
                                </v-col>
                            </v-row>

                            <v-row class="mb-4">
                                <v-col cols="4" class="font-weight-500">
                                    Paket Belajar
                                </v-col>
                                <v-col cols="8">
                                    <span
                                        class="darkgrey--text font-weight-bold"
                                    >
                                        TRYOUT SATUAN AMBIS SNBT/UTBK 2024
                                        EPISODE 05, PAKET KONSULTASI 1 SESI (30
                                        Menit)
                                    </span>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="4" class="font-weight-500">
                                    Persen Diskon
                                </v-col>
                                <v-col cols="8">
                                    <span
                                        class="darkgrey--text font-weight-bold"
                                    >
                                        20%
                                    </span>
                                </v-col>
                            </v-row>
                        </v-col>

                        <v-col cols="6" class="text-right">
                            <span class="mr-2 font-weight-700">GFVLGION</span>

                            <v-btn
                                color="#e2f0f7"
                                class="primary--text"
                                depressed
                            >
                                <v-icon class="mr-2" style="font-size: 18px">
                                    mdi-clipboard-outline
                                </v-icon>
                                Copy
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </div>

        <div class="mb-10 mt-2">
            <v-row>
                <v-col cols="4">
                    <v-card flat class="mt-5">
                        <v-card-text class="pa-5">
                            <div class="grey--text">Jumlah Voucher</div>
                            <div
                                class="font-weight-700 black--text mt-2"
                                style="font-size: 24px"
                            >
                                88 <span style="font-size: 14px">Voucher</span>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>

                <v-col cols="4">
                    <v-card flat class="mt-5">
                        <v-card-text class="pa-5">
                            <div class="grey--text">
                                Total Voucher Digunakan
                            </div>
                            <div
                                class="font-weight-700 black--text mt-2"
                                style="font-size: 24px"
                            >
                                3 <span style="font-size: 14px">Voucher</span>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>

                <v-col cols="4">
                    <v-card flat class="mt-5">
                        <v-card-text class="pa-5">
                            <div class="grey--text">Sisa Voucher</div>
                            <div
                                class="font-weight-700 black--text mt-2"
                                style="font-size: 24px"
                            >
                                85 <span style="font-size: 14px">Voucher</span>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </div>

        <v-card>
            <v-card-title> Daftar Kode Voucher </v-card-title>
            <v-divider />

            <app-datatable
                :items="data"
                :headers="headers"
                :has-action="false"
                :has-export="true"
                :has-duplicate="true"
                :has-custom-pagination="true"
                :has-custom-search="true"
                :custom-pagination-current-page="pagination.currentPage"
                :custom-pagination-per-page="pagination.perPage"
                :custom-pagination-total-pages="total"
                :custom-pagination-sort-mode="pagination.sortMode"
                v-on:selected="selectedRow = $event"
                v-on:exportClicked="exportTryout()"
                v-on:changePage="
                    pagination = { ...pagination, currentPage: $event }
                "
                v-on:changeSortMode="
                    pagination = { ...pagination, sortMode: $event }
                "
                v-on:doSearch="
                    search = $event.value;
                    tableKey = $event.key.value;
                    doSearch();
                "
            ></app-datatable>
        </v-card>

        <v-btn class="mt-7" color="#ec675e" dark depressed large>
            Nonaktifkan Kode Voucher
        </v-btn>

        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import _ from "lodash";
import AppSpinner from "@/modules/global/components/plugins/Spinner";
import DataTable from "@/modules/global/components/plugins/DataTable-c";
import axios from "axios";

export default {
    name: "notifications-template",

    components: {
        "app-datatable": DataTable,
        "app-spinner": AppSpinner,
    },

    data: function () {
        return {
            isLoading: false,
            selectedRow: "",
            total: 0,
            start_date: "",
            end_date: "",
            search: "",
            tableKey: "",
            sortBy: "",
            filters: "",
            pagination: {
                perPage: 20,
                currentPage: 1,
                totalPages: 0,
                sortMode: "desc",
            },
            data: [],
            problem: [],
            total_problem: 0,
            headers: [
                { text: "Email", value: "email", width: "300" },
                { text: "Order ID", value: "order_id", width: "200" },
                { text: "Tanggal Digunakan", value: "used_date" },
                { text: "Paket Group", value: "package_group_name" },
            ],
            filter_type: "ALL",
            menu: false,
            modal_date: false,
            modal_date2: false,
            date: "",
            date2: "",
        };
    },

    watch: {
        pagination() {
            this.fetchData();
        },
        filter_type() {
            if (this.filter_type === "ALL") {
                this.date = "";
                this.date2 = "";
            } else {
                const date = new Date(
                    Date.now() - new Date().getTimezoneOffset() * 60000,
                )
                    .toISOString()
                    .substr(0, 10);

                const date2 = new Date(
                    Date.now() - new Date().getTimezoneOffset() * 60000,
                )
                    .toISOString()
                    .substr(0, 10);

                this.date = date;
                this.date2 = date2;
            }
        },
    },

    mounted: function () {
        this.fetchData();
        this.fetchListProblem();
    },

    methods: {
        fetchData() {
            // const context = this;
            // const param = `?start_date=${context.start_date}&end_date=${context.end_date}&sort_by=${context.sortBy}&sort=${context.pagination.sortMode}&size=${context.pagination.perPage}&page=${context.pagination.currentPage}&search=${context.search}&tabel_key=${context.tableKey}`;
            // const url = `${process.env.API_BASE_URL}liveclass/admin/list-reports${param}`;

            // const authToken = JSON.parse(localStorage.getItem("token")).value;
            // const options = {
            //   headers: {
            //     Authorization: "Bearer " + authToken,
            //   },
            // };

            // context.user_groups = [];
            // axios.get(url, options).then(function (response) {
            //   if (response.status === 200) {
            //     context.data = response.data.reports;
            //     context.total = Math.ceil(
            //       response.data.total_report / context.pagination.perPage
            //     );
            //   }
            // });

            this.data = [
                {
                    no: 1,
                    id: 1,
                    order_id: "ORD123456",
                    email: "contoh1@email.com",
                    used_date: "2024-02-16",
                    package_group_name: "Belajar Bahasa",
                },
                {
                    no: 2,
                    id: 2,
                    order_id: "ORD789012",
                    email: "contoh2@email.com",
                    used_date: "2024-02-17",
                    package_group_name: "Belajar Matematika",
                },
                {
                    no: 3,
                    id: 3,
                    order_id: "ORD345678",
                    email: "contoh3@email.com",
                    used_date: "2024-02-18",
                    package_group_name: "Belajar Sains",
                },
                {
                    no: 4,
                    id: 4,
                    order_id: "ORD901234",
                    email: "contoh4@email.com",
                    used_date: "2024-02-19",
                    package_group_name: "Belajar Seni",
                },
                {
                    no: 5,
                    id: 5,
                    order_id: "ORD567890",
                    email: "contoh5@email.com",
                    used_date: "2024-02-20",
                    package_group_name: "Belajar Musik",
                },
                {
                    no: 6,
                    id: 6,
                    order_id: "ORD234567",
                    email: "contoh6@email.com",
                    used_date: "2024-02-21",
                    package_group_name: "Belajar Bahasa",
                },
                {
                    no: 7,
                    id: 7,
                    order_id: "ORD890123",
                    email: "contoh7@email.com",
                    used_date: "2024-02-22",
                    package_group_name: "Belajar Matematika",
                },
                {
                    no: 8,
                    id: 8,
                    order_id: "ORD456789",
                    email: "contoh8@email.com",
                    used_date: "2024-02-23",
                    package_group_name: "Belajar Sains",
                },
                {
                    no: 9,
                    id: 9,
                    order_id: "ORD012345",
                    email: "contoh9@email.com",
                    used_date: "2024-02-24",
                    package_group_name: "Belajar Seni",
                },
                {
                    no: 10,
                    id: 10,
                    order_id: "ORD678901",
                    email: "contoh10@email.com",
                    used_date: "2024-02-25",
                    package_group_name: "Belajar Musik",
                },
            ];
        },
        fetchListProblem() {
            const context = this;
            const param = `?start_date=${context.start_date}&end_date=${context.end_date}`;
            const url = `${process.env.API_BASE_URL}liveclass/admin/list-reports-problem${param}`;

            const authToken = JSON.parse(localStorage.getItem("token")).value;

            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };

            context.user_groups = [];
            axios.get(url, options).then(function (response) {
                if (response.status === 200) {
                    context.problem = response.data.total_report_problems;
                    context.total_problem = response.data.total_report;
                }
            });
        },
        doFilter() {
            this.menu = false;
            this.start_date = this.formatDate(this.date);
            this.end_date = this.formatDate(this.date2);

            this.fetchData();
            this.fetchListProblem();
        },
        doSearch() {
            if (this.tableKey === "class_date") {
                this.search = this.formatDate2(this.search);
            }
            this.fetchData();
        },
        updateVoucherCode: function () {
            var voucher_id = this.$route.query.id;
            this.$router.push({
                path: "/kode-voucher-form",
                query: { id: voucher_id },
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// VoucherCodeDetail.vue?360ec042